<style lang="scss" scoped>
@import '../assets/scss/_variables';

#main-form {
    display: flex;
    width: 100%;
    width: calc(100% - #{$grid-size * 2)});
    min-height: calc(100% - #{$grid-size * 2});
    position: absolute;
        top: $grid-size * 2;
        left: $grid-size * 2;
        z-index: 15;

    transform-origin: 100% 0;
    overflow: hidden;

    &.rotate-enter,
    &.rotate-leave-to {
        left: 70%;
        opacity: 0;

        .step:not(.is-active) {
            left: 100%;
        }

        @include media-larger('sm') {
            transform: rotate(-30deg);
        }
    }

    &.rotate-enter-active,
    &.rotate-leave-active {
        transition:
            left 0.5s $easing-easeOutCubic,
            opacity 0.25s ease-out,
            transform 0.5s $easing-easeOutCubic;

        .step:not(.is-active) {
            transition: left $transition-step-inactive-slide;
        }
    }
}

@include media-smaller('md') {
    #main-form {
        display: block;
        width: 100%;
        left: 0;
    }
}
</style>

<template>
    <transition name="rotate">
        <form id="main-form">
            <component
                v-for="(step, index) in steps"
                :is="step"
                :key="step"
                :index="index"
                :activeIndex="currentStep"
                @completed="stepCompleted"
                @set-active="currentStep = index"
            ></component>
        </form>
    </transition>
</template>

<script>
import extend from 'extend';
import scroller from 'vue-scrollto';
import easings from '@/utils/easings';
import Step1 from '@/components/steps/1.vue';
import Step2 from '@/components/steps/2.vue';
import Step3 from '@/components/steps/3.vue';

export default {
    components: {Step1, Step2, Step3},
    data () {
        return {
            data: {},
            steps: ['Step1', 'Step2', 'Step3'],
            currentStep: 0,
            isChangingStep: false
        };
    },
    methods: {
        stepCompleted (stepData) {
            extend(true, this.data, stepData);

            if (this.isChangingStep) {
                return;
            }

            if (this.currentStep >= (this.steps.length - 1)) {
                this.$store.dispatch(
                    'loading',
                    this.$store.dispatch('calculateEmissions', this.data).then((entry) => {
                        this.$router.push('/results/' + entry.id);

                        gtag('event', 'view', {
                            'event_label': 'Completed journey',
                            'event_category': 'journey'
                        });
                    })
                );
            } else {
                this.nextStep();
            }
        },
        nextStep () {
            if (this.$store.getters.viewport < 2) {
                scroller.scrollTo('body', {
                    duration: 800,
                    cancelable: false,
                    easing: easings.inOutCubic
                });

                this.isChangingStep = true;
                setTimeout(() => {
                    this.currentStep++;
                    this.isChangingStep = false;
                }, 500);
            } else {
                this.currentStep++;
            }
        }
    }
};
</script>
